import enviroment from '../enviroment.json'

export default {
    identity_api_url: enviroment.IDENTITY_API_URL || 'https://identity-api.id.autofact.qa/identity/v1',
    path_url: enviroment.PATH_URL || 'https://s3.amazonaws.com/docs.identity.qa/',
    process_time: enviroment.PROCESS_TIME || '20',
    camera_tag_record_seconds: enviroment.CAMERA_TAG_RECORD_SECONDS || '15',
    camera_tag_src_library: enviroment.CAMERA_TAG_SRC_LIBRARY || 'https://cameratag.com/api/v14/js/cameratag.min.js',
    process_time_unit_label: enviroment.PROCESS_TIME_UNIT_LABEL || 'MINUTOS',
    process_time_unit_days: enviroment.PROCESS_TIME_UNIT_DAYS || 'DÍAS',
    process_time_unit_hours: enviroment.PROCESS_TIME_UNIT_HOURS || 'HORAS',
    resize_image_width: enviroment.RESIZE_IMAGE_WIDTH || '800',
    resize_image_height: enviroment.RESIZE_IMAGE_HEIGHT || '800',
    resize_image: enviroment.RESIZE_IMAGE || 'true',
    identity_api_key: enviroment.IDENTITY_API_KEY,
    view_testing: enviroment.VIEW_TESTING || 'true',
    camera_tag_id: enviroment.CAMERA_TAG_ID,
    notary_declaration_timer_button: enviroment.NOTARY_DECLARATION_TIMER_BUTTON || '20',
    notary_declaration_general_timer_button: enviroment.NOTARY_DECLARATION_GENERAL_TIMER_BUTTON || '86400',
    notary_declaration_video_url: enviroment.NOTARY_DECLARATION_VIDEO_URL || 'https://s3.amazonaws.com/media.identity/meet',
    force_show_camera_next_button: enviroment.FORCE_SHOW_CAMERA_NEXT_BUTTON || 'true',
    upload_video_test: enviroment.UPLOAD_VIDEO_TEST || 'false',
    autocapture_library: enviroment.AUTOCAPTURE_LIBRARY || 'https://sandbox-web-plugins.s3.amazonaws.com/autocapture/autocapture.js',
    liveness_library: enviroment.LIVENESS_LIBRARY || 'https://sandbox-web-plugins.s3.amazonaws.com/liveness/js/liveness.js',
    camera_library: enviroment.CAMERA_LIBRARY || 'default',
    autocapture_url_lbac: enviroment.AUTOCAPTURE_URL_LBAC|| null,
    autocapture_alt_server: enviroment.AUTOCAPTURE_ALT_SERVER || null,
    liveness_alt_server: enviroment.LIVENESS_ALT_SERVER || null,
    liveness_url_lbliv: enviroment.LIVENESS_URL_LBLIV || null,
    validate_declaration: enviroment.VALIDATE_DECLARATION  === 'true',
    min_transcript_accuracy: enviroment.MIN_TRANSCRIPT_ACCURACY || '0.5',
    retail_company_id: enviroment.RETAIL_COMPANY_ID || '418',
    af_public_url: enviroment.AF_PUBLIC_URL || 'https://transferencias.autofact.qa/',
    timeout_autocapture_seconds: (enviroment.TIMEOUT_AUTOCAPTURE_SECONDS || 30) * 1000,
    customThresholds: {
      brightnessMin: Number(enviroment.BRIGHTNESS_MIN_THRESHOLD) || 50,
      brightnessMax: Number(enviroment.BRIGHTNESS_MAX_THRESHOLD) || 200,
      contrast: Number(enviroment.CONTRAST_THRESHOLD) || 30,
      laplacian: Number(enviroment.LAPLACIAN_THRESHOLD) || 0.02,
      sobel: Number(enviroment.SOBEL_THRESHOLD) || 50,
    },
    fingerprintCustomThresholds: {
      brightnessMin: Number(enviroment.FINGERPRINT_BRIGHTNESS_MIN_THRESHOLD) || 50,
      brightnessMax: Number(enviroment.FINGERPRINT_BRIGHTNESS_MAX_THRESHOLD) || 200,
      contrast: Number(enviroment.FINGERPRINT_CONTRAST_THRESHOLD) || 30,
      laplacian: Number(enviroment.FINGERPRINT_LAPLACIAN_THRESHOLD) || 0.02,
      sobel: Number(enviroment.FINGERPRINT_SOBEL_THRESHOLD) || 30,
    },
    limitAttemptsQualityCheck: Number(enviroment.LIMIT_ATTEMPTS_QUALITY_CHECK)  || 3,
    strategyCameraSelection: enviroment.STRATEGY_CAMERA_SELECTION || 'bestCamera',
    qRValidationEnabled: enviroment.QR_VALIDATION_ENABLED || 'true',
    debugMode: enviroment.DEBUG_MODE || 'false',
    whatsappNumber: enviroment.WHATSAPP_NUMBER || '+56 9 8559 9683',
    customerServiceHours: enviroment.CUSTOMER_SERVICE_HOURS || 'Atendemos de lunes a viernes de 9.00 a 17.00 hrs.',
    customerServiceWelcomeMessage: enviroment.CUSTOMER_SERVICE_WELCOME_MESSAGE || 'Hola Soporte AF, necesito ayuda con mi proceso firma',
    directCustomerServiceCompaniesIds: enviroment.DIRECT_CUSTOMER_SERVICE_COMPANIES_IDS ? enviroment.DIRECT_CUSTOMER_SERVICE_COMPANIES_IDS.split(',').map(v => parseInt(v, 10)) : [],
    supportNumber: enviroment.SUPPORT_NUMBER || '56985599683',
    regions: enviroment.REGIONS || false,
    finalRedirectCountdownSeconds: Number(enviroment.FINAL_REDIRECT_COUNTDOWN_SECONDS || 5),
};
